/**
 * useTutorThemeScope — bascule le design system sur le thème tuteur (teal) le temps de l'espace tuteur.
 *
 * La portée commune des espaces (`createSpaceThemeScope`), au thème du tuteur : Clair par défaut
 * (`tutorAppearancePreference`), sa nuit (`tutorDark`) au choix dans « Apparence ». Tenue par la
 * coquille (`TutorNavigator`) et par chaque écran poussé du design system (`tutorSpaceBridge`).
 */
import { useColorScheme } from "react-native"

import { isDarkFor } from "./appearanceTheme"
import { createSpaceThemeScope } from "./spaceThemeScope"
import { useTutorAppearancePreference } from "./tutorAppearancePreference"

export const useTutorThemeScope = createSpaceThemeScope(() => {
    const preference = useTutorAppearancePreference()
    return { theme: isDarkFor(useColorScheme(), preference) ? "tutorDark" : "tutor", preference }
})
